import {
  ThemeProvider,
  getTheme,
  heHogeSchoolTaalTokens,
} from "@infinitaslearning/pixel-design-system";
import React from "react";
// @ts-ignore
import { debugContextDevtool } from "react-context-devtool";
import ReactDOM from "react-dom";

import { ToastMethods } from "components/ToastNotification";

import "./i18n";
import App from "./App";

ToastMethods.initToast({});

const container = document.getElementById("root");

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={getTheme(heHogeSchoolTaalTokens)}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  container,
);

// Attach root container
debugContextDevtool(container, {});
